import { API } from "config";
import request from "utilities/request";
import httpErrorStatus from "utilities/httpErrorStatus";
import { ScopeFilesResponseSchema } from "../types/ScopeFile";
import type { ScopeFile } from "../types/ScopeFile";

const fileApiBaseUrl = API.fileApi.url;

/**
 * Every file stored for a chat thread, in the File API's order. A thread's
 * retention scope ID is its thread ID. The File API creates the scope on the
 * first upload, so a 404 means the thread has no files yet.
 */
export async function getScopeFiles(
  threadId: string,
  getAccessToken: () => Promise<string>
): Promise<ScopeFile[]> {
  const accessToken = await getAccessToken();
  const url = `${fileApiBaseUrl}/api/v1/scopes/${threadId}/files/variants`;

  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  let response: Response;
  try {
    response = await request(url, options);
  } catch (error: unknown) {
    if (httpErrorStatus(error) === 404) return [];
    throw error;
  }

  return ScopeFilesResponseSchema.parse(await response.json());
}
